import { render } from "./column.html?vue&type=template&id=f97934ee&external"
import script from "./column.js?vue&type=script&lang=js&external"
export * from "./column.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__